(() => {
  if (window.zeusAboutPage) { window.zeusAboutPage.init(document); return; }
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const calm = () => reduced.matches || document.documentElement.dataset.zjMotion === 'false';
  function init(scope) {
    const roots = [...scope.querySelectorAll('[data-zj-about]')];
    for (const root of roots) {
      if (root.dataset.aboutReady) continue;
      root.dataset.aboutReady = 'true';
      root.querySelectorAll('video').forEach(film => {
        film.muted = true;
        let wasPlaying = false;
        if (calm()) { film.removeAttribute('autoplay'); film.pause(); }
        else film.play().catch(() => {});
        reduced.addEventListener('change', () => { if (calm()) film.pause(); });
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) { wasPlaying = !film.paused; film.pause(); }
          else if (wasPlaying && !calm()) film.play().catch(() => {});
        });
      });
      const list = root.querySelector('.process-tabs');
      const tabs = [...root.querySelectorAll('.process-tab')];
      if (list && tabs.length) {
        list.setAttribute('role', 'tablist');
        function activate(active, focus = false) {
          tabs.forEach(tab => {
            const selected = tab === active;
            tab.setAttribute('role', 'tab');
            tab.setAttribute('aria-selected', String(selected));
            tab.tabIndex = selected ? 0 : -1;
            const panel = root.querySelector(`#${CSS.escape(tab.getAttribute('aria-controls'))}`);
            if (!panel) return;
            panel.setAttribute('role', 'tabpanel');
            panel.setAttribute('aria-labelledby', tab.id);
            panel.tabIndex = 0;
            panel.hidden = !selected;
            panel.classList.toggle('entering', selected);
          });
          if (focus) active.focus();
        }
        tabs.forEach((tab,index) => {
          tab.addEventListener('click', () => activate(tab));
          tab.addEventListener('keydown', event => {
            let next;
            if (event.key === 'ArrowRight') next = (index+1)%tabs.length;
            if (event.key === 'ArrowLeft') next = (index-1+tabs.length)%tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = tabs.length-1;
            if (next !== undefined) { event.preventDefault(); activate(tabs[next],true); }
          });
        });
        root.addEventListener('shopify:block:select', event => {
          const panel = event.target.closest('.process-panel');
          if (panel) {
            const tab = tabs.find(item => item.getAttribute('aria-controls') === panel.id);
            if (tab) activate(tab);
          }
        });
        activate(tabs[0]);
      }
      const reveals = [...root.querySelectorAll('.reveal')];
      if (!calm() && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          for (const entry of entries) if (entry.isIntersecting) {
            entry.target.classList.remove('pending');
            entry.target.classList.add('in');
            observer.unobserve(entry.target);
          }
        }, {threshold:0.06});
        reveals.forEach(element => { element.classList.add('pending'); observer.observe(element); });
      }
    }
  }
  window.zeusAboutPage = {init};
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
